/**
 * Requirements are to use the canonical URL of the product page as the product’s url (and Offer.url).
 * Avoid URLs with dynamic parameters that represent variants (for example, ?variant=12345)
 */
export function buildProductUrl(pathname: string | null) {
  let path = '/products';
  const splitPath = pathname?.split(path);
  if (splitPath) {
    const localePath = splitPath[0].startsWith('/en') ? '' : splitPath[0];
    path = `${localePath}${path}${(splitPath[1] || '').replace(/\/$/, '')}`;
  }
  return `https://${process.env.NEXT_PUBLIC_VANITY_DOMAIN}${path}`;
}
